import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Slider from "../components/Silder";
import NewProducts from "../components/NewProducts";
import Banner from "../components/Banner";
import TrendProducts from "../components/TrendProducts";
import TimeBanner from "../components/TimeBanner";
import ListViewer from "../components/ListViewer";
import Blog from "../components/Blog";

const HomePage = () => {
  return (
    <div >
      {/* <Header /> */}
      <Slider />
      <NewProducts/>
      <Banner/>
      <TrendProducts/>
      <TimeBanner/>
      <ListViewer/>
      {/* <Blog/> */}
      {/* <Footer /> */}
    </div>
  );
};

export default HomePage;
